// @flow

import React, {type Node} from 'react';
import {CSSTransition} from 'react-transition-group';

type Props = {
  children: Node,
};

export const BieFader = ({children, ...other}: Props) => (
  <CSSTransition
    appear={true}
    timeout={250}
    classNames="bd"
    unmountOnExit
    {...other}
  >
    {children}
  </CSSTransition>
);
